module.exports = __webpack_public_path__ + "static/media/12919781_995128897241167_3949618613433831561_n.cdbe825f.jpg";